import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { getSortedModelValues } from '@app/shared/helpers/common.helper';
import {
  DisciplineModel,
  EgiModel, EgiSuffixModel, ItemStatusModel, PlaceELRModel, SignalboxDUModel,
  SuffixModel, TypeIdModel
} from '@app/models/failure/master.model';
import { ItemModel } from '@app/models/failure/item.model';
import { PeaIncidentTypeModel } from '@app/models/failure/pea.model';
import { MasterService } from './failure/master.service';
import { AdminService } from './failure/admin.service';
import { ProfileService } from './common/profile.service';
import { ItemService } from './failure/item.service';
import { PeaService } from './failure/pea.service';

@Injectable({ providedIn: 'root' })
export class ApploadService {

  constructor(
    private profileService: ProfileService,
    private masterService: MasterService,
    private itemService: ItemService,
    private peaService: PeaService,
    private adminService: AdminService) { }

  async initApploadService() {
    if (this.getRouteControl() === null) { this.setRouteControl('355593:DERBY:DER'); }
  }

  getUserFromSessionStorage() {
    return JSON.parse(sessionStorage.getItem('profile'));
  }

  setRouteControl(routeControl: string) { sessionStorage.setItem('routeControl', routeControl); }
  getRouteControl(key: string = null) {
    let routeControl = sessionStorage.getItem('routeControl') || null;
    return key === null ? routeControl : routeControl.split(':')[key === 'id' ? 0 : key === 'name' ? 1 : 2];
  }

  getActiveDirectoryProfiles(searchValue: string): Observable<any[]> {
    return this.profileService.getActiveDirectoryUsers(searchValue).pipe(tap(x => (x)));
  }
  getUsersList(searchValue: string): Observable<any[]> {
    return this.profileService.getUsersList(searchValue).pipe(tap(x => (x)));
  }

  setDeliveryUnit(duDesc: string) { sessionStorage.setItem('dunitIds', duDesc); }
  getDeliveryUnit(): string { return sessionStorage.getItem('dunitIds'); }

  private modelOrganizationData: { type: string, value: string, result: any }[] = [];
  public getModelOrganizationData(type: string, value: string, reset: boolean = false): Observable<any> {

    let searchResult: any;
    if (reset) { this.modelOrganizationData = []; }

    if (this.modelOrganizationData?.length > 0) {
      searchResult = this.modelOrganizationData.find(
        x => x.type.toLowerCase() === type.toLowerCase() && x.value.toLowerCase() === value.toLowerCase()
      );
    }

    return (searchResult && searchResult.result['organizationData'].length > 0)
      ? of(searchResult.result)
      : this.masterService.getRbacOrganizationData(type, value)
        .pipe(tap(x => {
          this.modelItem = [];
          this.modelPlaceELR = [];
          this.modelItemGIS = [];
          this.modelOrganizationData.push({ type: type, value: value, result: x });
          return x;
        }));
  }

  private modelDeliveryUnit: any;
  public getModelDeliveryUnit(controlcentre: string, reset: boolean = false): Observable<any> {
    if (reset) this.modelDeliveryUnit = [];

    return (this.modelDeliveryUnit !== undefined && this.modelDeliveryUnit !== null && Object.keys(this.modelDeliveryUnit).length == 2)
      ? of(this.modelDeliveryUnit)
      : this.masterService.getRbacDeliveryUnits(controlcentre)
        .pipe(tap(x => {
          this.modelItem = [];
          this.modelPlaceELR = [];
          this.modelItemGIS = [];
          this.modelDeliveryUnit = x;
          return this.modelDeliveryUnit;
        }));
  }

  private modelDiscipline: TypeIdModel[] = [];
  private disciplineRefCodeValue: any;
  fetchServiceModel(porpName: string, refCodeFormat = false): Observable<any[]> {
    if (!refCodeFormat && porpName === 'ENG' && this.modelDiscipline?.length > 0) return of(this.modelDiscipline);
    if (refCodeFormat && porpName === 'ENG' && this.disciplineRefCodeValue?.hasOwnProperty('referenceCode')) return of(this.disciplineRefCodeValue);
    return this.masterService.getMasterReferenceValues({ 'mode': 1, 'refType': porpName })
      .pipe(tap(x => {
        console.log(porpName, x.length);
        if (porpName === 'ENG') {
          this.disciplineRefCodeValue = x;
          if (x !== null && x.hasOwnProperty('referenceCode')) {
            this.modelDiscipline = getSortedModelValues(x['referenceCode'].map((dis) => {
              return { masterId: dis.identifier, name: dis.title.toUpperCase(), code: dis.code, value: dis.title.toUpperCase(), masterType: 'ENG', referenceGroup: dis.referenceGroup };
            }));
          }
        }
        return;
      }));
  }

  private getEqValue$;
  setEquipmentValue(value: any) { this.getEqValue$ = value; }
  getEquipmentValue() { return this.getEqValue$; }

  private refTypeFailureFunction: any;
  private modelFailureFunction: TypeIdModel[] = [];
  public getModelFailureFunction(): Observable<any> {
    return (this.refTypeFailureFunction && this.modelFailureFunction?.length > 0)
      ? of(this.modelFailureFunction)
      : this.masterService.getMasterReferenceValues({ 'mode': 1, 'refType': 'FFN' })
        .pipe(tap(x => {
          if (x !== null && x.hasOwnProperty('referenceCode')) {
            this.refTypeFailureFunction = x;
            this.modelFailureFunction = this.setModelFailureFunction(x);
          }
        }));
  }
  public setModelFailureFunction(x) {
    return getSortedModelValues(x['referenceCode'].map((fn) => {
      return {
        masterId: fn.identifier, name: fn.title.toUpperCase(), code: fn.code, value: fn.title.toUpperCase(), masterType: 'FUNCTION',
        failureMode: fn['referenceGroup'].map((rg) => { return { masterId: rg.identifier, name: rg.title.toUpperCase(), code: fn.code, value: fn.title.toUpperCase(), masterType: 'DEFECT' } })
      };
    }));
  }

  private modelItem: ItemModel[] = [];
  public getModelItem(): Observable<ItemModel[]> {
    return (this.modelItem?.length > 0)
      ? of(this.modelItem)
      : this.itemService.getItem({ 'deliveryUnit': this.getDeliveryUnit() })
        .pipe(tap(x => { return this.modelItem = getSortedModelValues(x, 'calculatedDesc'); }));
  }

  private modelItemSearch: { duName: string, searchKey: string, result: ItemModel[] }[] = [];
  public getModelItemSearch(value: string): Observable<ItemModel[]> {
    let searchResult: any;
    let routeControlName = this.getRouteControl('name');
    routeControlName = routeControlName && routeControlName != null ? routeControlName.replace(' ', '') : routeControlName;
    if (this.modelItemSearch?.length > 0) {
      searchResult = this.modelItemSearch.find(
        x =>
          x.searchKey.toLowerCase() == value.trim().toLowerCase() &&
          x.duName.toLowerCase() == this.getDeliveryUnit().toLowerCase());
    }

    return (searchResult && searchResult.result?.length > 0)
      ? of(searchResult.result)
      : this.itemService
        .getItemRedis(routeControlName, value)
        .pipe(tap(x => {
          if (x != null) {
            x = getSortedModelValues(x, 'calculatedDesc');
            this.modelItemSearch.push({ duName: this.getDeliveryUnit(), searchKey: value.trim(), result: x });
            return x;

          } else {
            return this.getItemFromDatabase(value);
          }

        }), catchError(err => {
          return this.getItemFromDatabase(value);
        }));
  }
  private getItemFromDatabase(value: string): Observable<ItemModel[]> {
    return this.itemService
      .getItem({ 'deliveryUnit': this.getDeliveryUnit(), 'searchEquipmentString': value })
      .pipe(tap(x => {
        x = getSortedModelValues(x, 'calculatedDesc');
        this.modelItemSearch.push({ duName: this.getDeliveryUnit(), searchKey: value.trim(), result: x });
        return x;
      }));
  }

  private modelItemGIS: ItemModel[] = [];
  public getModelItemGIS(): Observable<ItemModel[]> {
    return (this.modelItemGIS?.length > 0)
      ? of(this.modelItemGIS)
      : this.itemService.getItemGIS({ 'deliveryUnit': this.getDeliveryUnit() })
        .pipe(tap(x => { return this.modelItemGIS = getSortedModelValues(x, 'calculatedDesc'); }));
  }

  private modelGISItemSearch: { duName: string, searchKey: string, result: ItemModel[] }[] = [];
  public getModelGISItemSearch(value: string): Observable<ItemModel[]> {
    let searchResult;
    if (this.modelGISItemSearch?.length > 0) {
      searchResult = this.modelGISItemSearch.find(
        x => x.searchKey.toLowerCase() == value.trim().toLowerCase() &&
          x.duName.toLowerCase() == this.getDeliveryUnit().toLowerCase()
      );
    }
    return (searchResult && searchResult.result?.length > 0)
      ? of(searchResult.result)
      : this.itemService
        .getItemGIS({ 'deliveryUnit': this.getDeliveryUnit(), 'searchEquipmentString': value })
        .pipe(tap(x => {
          x = getSortedModelValues(x, 'calculatedDesc');
          this.modelGISItemSearch.push({ duName: this.getDeliveryUnit(), searchKey: value.trim(), result: x });
          return x;
        }));
  }

  private modelSignalBox: SignalboxDUModel[] = [];
  public getModelSignalBox(): Observable<SignalboxDUModel[]> {
    return (this.modelSignalBox?.length > 0)
      ? of(this.modelSignalBox)
      : this.masterService.getSignalboxByDUnit(this.getDeliveryUnit())
        .pipe(tap(x => { return this.modelSignalBox = getSortedModelValues(x, 'SignalBoxName') }));
  }

  private modelSuffix: SuffixModel[] = [];
  public getModelSuffix(): Observable<SuffixModel[]> {
    return (this.modelSuffix?.length > 0)
      ? of(this.modelSuffix)
      : this.masterService.getSuffix()
        .pipe(tap(x => { return this.modelSuffix = getSortedModelValues(x, 'suffixName'); }));
  }

  private modelPlace: any[] = [];
  public getModelPlaceMaster(): Observable<any[]> {
    return (this.modelPlace?.length > 0)
      ? of(this.modelPlace)
      : this.masterService.getPlace().pipe(tap(x => { return this.modelPlace = getSortedModelValues(x, 'name'); }));
  }

  private modelELr: any[] = [];
  public getModelElr(): Observable<any[]> {
    return (this.modelELr?.length > 0)
      ? of(this.modelELr)
      : this.masterService.getElr().pipe(tap(x => { return this.modelELr = getSortedModelValues(x, 'elr'); }));
  }

  private modelEgi: EgiModel[] = [];
  public getModelEgi(): Observable<EgiModel[]> {
    return (this.modelEgi?.length > 0)
      ? of(this.modelEgi)
      : this.masterService.getEgi().pipe(tap(x => { return this.modelEgi = getSortedModelValues(x, 'egiType'); }));
  }

  public getModelEgiSuffix(suffixId: number): Observable<EgiSuffixModel[]> {
    return this.masterService.getEgiBySuffixId(suffixId).pipe(tap(x => { return getSortedModelValues(x, 'egi') }));
  }

  
  public getModelDisiplineByEgi(egi: string): Observable<DisciplineModel[]>{
    return this.masterService.getDisiplineByEgi(egi);
  }

  private disciplineMod: DisciplineModel[] = [];
  public getModelDisipline(): Observable<DisciplineModel[]>{
    return this.masterService.getDisipline().pipe(tap(x => { return this.disciplineMod = getSortedModelValues(x, 'disciplineName'); }));
  }

  private modelEgiSuffix: EgiSuffixModel[] = [];
  public getModelEgiSuffixMaster(): Observable<EgiSuffixModel[]> {
    return (this.modelEgiSuffix?.length > 0)
      ? of(this.modelEgiSuffix)
      : this.adminService.getSuffixEgiRelationData().pipe(tap((x: any) => {
        return this.modelEgiSuffix = getSortedModelValues(x.filter(e => e.isActive === 'Y' && e.isDelete === 'N'), 'suffixName');
      }));
  }

  private modelDisciplineEgi: { discipline: string, result: EgiModel[] }[] = [];
  public getModelEgiDiscipline(discipline: string): Observable<EgiModel[]> {
    let searchResult;
    if (this.modelDisciplineEgi?.length > 0) {
      searchResult = this.modelDisciplineEgi.find(
        x => x.discipline.toLowerCase() == discipline.trim().toLowerCase());
    }
    return (searchResult && searchResult.result.length > 0)
      ? of(searchResult.result)
      : this.masterService.getEgiByDisipline(discipline).pipe(tap(x => {
        console.log('egidis', x);
        x = getSortedModelValues(x, 'egiType')
        this.modelDisciplineEgi.push({ discipline: discipline.trim().toLowerCase(), result: x })
        return x;
      }));
  }


  public getModelSuffixEgi(egi: string) {
    return this.masterService.getSuffixByEgiId(egi);
  }

  public getModelSymptomSuffix(suffixId: number): Observable<TypeIdModel[]> {
    return this.masterService.getSymptomBySuffixId(suffixId)
      .pipe(tap(x => { return getSortedModelValues(x, 'name'); }));
  }

  private modelPlaceELR: PlaceELRModel[] = [];
  private modelPlaceELRGIS: PlaceELRModel[] = [];
  public getModelPlace(gisView: boolean = false): Observable<PlaceELRModel[]> {
    let rId = Number(this.getRouteControl('id'));
    if (gisView) {
      return (this.modelPlaceELRGIS?.length) > 0 ? of(this.modelPlaceELRGIS)
        : this.masterService.getPlacesAndElrByIfcId(rId, gisView)
          .pipe(tap(x => { return this.modelPlaceELRGIS = getSortedModelValues(x, 'placeName') }));

    } else {
      return (this.modelPlaceELR?.length) > 0 ? of(this.modelPlaceELR)
        : this.masterService.getPlacesAndElrByIfcId(rId, gisView)
          .pipe(tap(x => { return this.modelPlaceELR = x; }));
    }
  }

  public getItemHistory(itemId: string, placeId: number) {
    return this.itemService.getProblemHistoryById(itemId, placeId);
  }

  private modelSincsIncidentType: PeaIncidentTypeModel[] = [];
  public getModelSincsIncidentType(): Observable<PeaIncidentTypeModel[]> {
    return (this.modelSincsIncidentType?.length > 0)
      ? of(this.modelSincsIncidentType)
      : this.peaService.getIncidentTypes().pipe(tap(x => { return this.modelSincsIncidentType = x; }));
  }

  private modelItemStatus: ItemStatusModel[] = [];
  public getItemStatus(): Observable<ItemStatusModel[]> {
    return (this.modelItemStatus?.length > 0)
      ? of(this.modelItemStatus)
      : this.masterService.getItemStatus().pipe(tap(x => { return this.modelItemStatus = x; }));
  }

}
